<template>
    <b-row class="row button-row mx-auto">

        <div class="col-md-6 mt-sm-4 mt-xs-4">
            <a href="#industrySolutions">
                <div>
                    <button type="button" class="btn btn-outline-success hide-btn-focus ef-btn ">
                        Industry Solutions
                    </button>
                </div>
            </a>
        </div>

        <div class="col-md-6 mt-sm-4 mt-xs-4">
            <a href="/casestudies">
                <div>
                    <router-link :to="`/casestudies`"> </router-link>
                    <button type="button" class="btn btn-outline-success hide-btn-focus ef-btn">
                        Case Studies
                    </button>
                </div>
            </a>
        </div>
    </b-row>
</template>

<script>

export default {
    data: function () {
        return {};
    },
    methods: {
        closeModal() {
            this.$bvModal.hide('how-it-works')
        },
        async onReady() {
            this.isYoutubeReady = true;
            await this.$refs.youtube.player.playVideo();
        },
    },

};

</script>

<style lang="scss" scoped>
.button-row {
    padding-top: 30px;
    padding-bottom: 100px;
    width: fit-content;

}

.hide-btn-focus:focus {
    box-shadow: none !important;
}

.ef-btn {
    width: 250px !important;
}

.btn {
    margin-top: 10px;
}
</style>
